---
title: blog Structure
coverImage: /blog/assets/images/project-structure.avif
date: 2023-09-26T02:32:00.000Z
excerpt: How code and structure are organized.
hidden: false
tags:
  - Blog
  - Documentation
---

<script>import CodeBlock from "@lib/components/molecules/CodeBlock.svelte";</script>

This project follows the a SPA style architecture, with a components library, pages directory, all mounted inside an App component, with routing handled by Navaid. When the code is deployed, the svelte code is compiled to vanillaJS and everything is bundled with Vite into a few files.

## Pages

Pages are in the /src/Pages directory

- There are two different page layouts in this site: the "Waves" layout, which all pages inside the `(waves)` folder use, and the "Blog Article" layout, which all pages inside the `(blog-article)` folder use;

## Blog Posts

To know how the blog posts are created and parsed, check out [How Blog Posts Work](/blog-explainer).

### Deployment

When the frontend is compiled with Svelte and bundled with Vite, the markdown files are compiled into svelte components by MDsvex, then copied into `./svelte_front/dist/assets/md`.
When they are parsed, the
